<template>
  <SalesDashboardCard title="Refunds" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="icon">
      <span class="dashboard-card-icon dashboard-card-icon-refunds" />
    </div>
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else class="row">
        <div class="col-6 d-flex flex-column">
          <span class="refund-covered-title">Carrier covered</span>
          <span class="refund-value">$ {{ data.carrier_covered }}</span>
        </div>
        <div class="col-6 d-flex flex-column">
          <span class="refund-covered-title">Office covered</span>
          <span class="refund-value">$ {{ data.office_covered }}</span>
        </div>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader.vue';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];
export default {
  components: { SalesDashboardCard, Loader },
  data() {
    return {
      loading: false,
      filters,
      selectedFilter: filters[2],
      data: {
        office_covered: 0,
        carrier_covered: 0,
      },
    };
  },
  watch: {
    selectedFilter() {
      this.getRefunds();
    },
  },
  mounted() {
    this.getRefunds();
  },
  methods: {
    getRefunds() {
      this.loading = true;
      axios
        .get(
          `/sales/refunds?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          this.data = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
.refund-value {
  font-size: 20px;
  font-weight: 500;
}

.refund-covered-title {
  font-size: 12px;
  font-weight: 400;
  color: #bec0ca;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/Refunds.vue